import { defmulti } from "@thi.ng/defmulti";
import { Type } from "@thi.ng/geom-api";
import { dispatch } from "../internal/dispatch";
import { edgeIterator } from "../internal/edges";
import { vertices } from "./vertices";
export const edges = defmulti(dispatch);
edges.addAll({
    [Type.AABB]: ($) => {
        const [a, b, c, d, e, f, g, h] = vertices($);
        return [
            [a, b],
            [b, c],
            [c, d],
            [d, a],
            [e, f],
            [f, g],
            [g, h],
            [h, e],
            [a, e],
            [b, f],
            [c, g],
            [d, h],
        ];
    },
    [Type.POLYGON]: ($) => edgeIterator($.points, true),
    [Type.POLYLINE]: ($) => edgeIterator($.points),
    [Type.RECT]: ($) => edgeIterator(vertices($), true),
});
edges.isa(Type.LINE, Type.POLYLINE);
edges.isa(Type.QUAD, Type.POLYGON);
edges.isa(Type.TRIANGLE, Type.POLYGON);
